import React from 'react';

export default function Inspireimg() {
  return (
    <div>
      <img
        className="w-full object-cover h-56 border-sky-400 border-2"
        alt="earth"
        src="https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
      />
    </div>
  );
}
